//tooltip
$(function () {
    $('[data-toggle="tooltip"]').tooltip();
    //popover
    var popoverTriggerList = [].slice.call(
        document.querySelectorAll('[data-bs-toggle="popover"]')
    );
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        var popover = new bootstrap.Popover(popoverTriggerEl, {
            trigger: "hover focus",
        });
        return popover;
    });
});

//sidebar off-canvas
$(function () {
    $('[data-bs-toggle="offcanvas"]').on("click", function () {
        $("#sidebar").removeClass("sidebar sidebar-offcanvas");
        $("#sidebar").addClass("sidebar offcanvas offcanvas-end");
    });
    $(document).on("click", function (event) {
        var clickOver = $(event.target);
        var _opened = $(".offcanvas").hasClass("show");
        var overclick = clickOver[0];
        var elementopadre = overclick.closest(".offcanvas");
        var clickdentrocuadro = false;
        var hamburger = clickOver.hasClass("bi-list");

        if (elementopadre != null) {
            clickdentrocuadro = elementopadre.classList.contains("offcanvas");
        }
        if (clickdentrocuadro == false && hamburger == false) {
            if (_opened === true) {
                $(".offcanvas").removeClass("show");
            }
        }
    });

    $(document).on("click", ".nav-item-ciudadano", function (event) {
        event.preventDefault();
        let id = $(this).data("id");
        var linkElement = $(this).find("a"); // Find the <a> element within the <li>
        var hrefValue = linkElement.attr("href");
        try {
            $.ajax({
                url: `${urls.validarServicio}/${id}`,
                method: "GET",
                dataType: "json",
                processData: false,
                contentType: false,
            })
                .done(function (response) {
                    if (response.isSuccess) {
                        window.location.href = hrefValue;
                    } else {
                        Swal.fire({
                            icon: "info",
                            title: "Alerta",
                            text: response.message,
                        });
                    }
                })
                .fail(function () {
                    Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: response.message,
                    });
                })
                .always(function () {
                    $("[type='submit']").prop("disabled", false);
                });
        } catch (e) {
            console.log("se ha presentado un error", e);
        }
    });
});

(function ($) {
    "use strict";
    $(function () {
        var body = $("body");
        var contentWrapper = $(".content-wrapper");
        var scroller = $(".container-scroller");
        var footer = $(".footer");
        var sidebar = $(".sidebar");

        function addActiveClass(element) {
            if (element.attr("href") == current) {
                $(element.parents(".nav-item")).addClass("active");
                //if (element.parents('.sub-menu').length) {
                //    element.closest('.collapse').addClass('show');
                //    element.addClass('active');
                //}
                //else {
                //    element.addClass('active');
                //}
            }
        }

        var current = location.pathname;
        $(".nav li a", sidebar).each(function () {
            var $this = $(this);
            addActiveClass($this);
        });

        //Close other submenu in sidebar on opening any

        sidebar.on("show.bs.collapse", ".collapse", function () {
            sidebar.find(".collapse.show").collapse("hide");
        });

        //MenuCiudadano con  d-hover.activado
        var menuRegistrando = document.querySelector("[data-registrar='Registrando']");
        var menuMiCaso = document.querySelector("[data-mi-caso='miCaso']");

        if (current == "/Ciudadano/Registrar") {
            menuRegistrando.classList.add("activado");
        }
        if (current == "/Servicio/Estado") {
            menuMiCaso.classList.add("activado");
        }
        //MenuCiudadano con  d-hover.activado 

        //Change sidebar and content-wrapper height
        applyStyles();

        function applyStyles() {
            //Applying perfect scrollbar
            if (!body.hasClass("rtl")) {
                if (
                    $(".settings-panel .tab-content .tab-pane.scroll-wrapper")
                        .length
                ) {
                    const settingsPanelScroll = new PerfectScrollbar(
                        ".settings-panel .tab-content .tab-pane.scroll-wrapper"
                    );
                }
                if ($(".chats").length) {
                    const chatsScroll = new PerfectScrollbar(".chats");
                }
                if (body.hasClass("sidebar-fixed")) {
                    if ($("#sidebar").length) {
                        var fixedSidebarScroll = new PerfectScrollbar(
                            "#sidebar .nav"
                        );
                    }
                }
            }
        }

        $('[data-bs-toggle="minimize"]').on("click", function () {
            if (
                body.hasClass("sidebar-toggle-display") ||
                body.hasClass("sidebar-absolute")
            ) {
                body.toggleClass("sidebar-hidden");
            } else {
                body.toggleClass("sidebar-icon-only");
            }
        });

        //checkbox and radios
        $(".form-check label,.form-radio label").append(
            '<i class="input-helper"></i>'
        );

        //Horizontal menu in mobile
        $('[data-toggle="horizontal-menu-toggle"]').on("click", function () {
            $(".horizontal-menu .bottom-navbar").toggleClass("header-toggled");
        });
        // Horizontal menu navigation in mobile menu on click
        var navItemClicked = $(".horizontal-menu .page-navigation >.nav-item");
        navItemClicked.on("click", function (event) {
            if (window.matchMedia("(max-width: 991px)").matches) {
                if (!$(this).hasClass("show-submenu")) {
                    navItemClicked.removeClass("show-submenu");
                }
                $(this).toggleClass("show-submenu");
            }
        });

        $(window).scroll(function () {
            if (window.matchMedia("(min-width: 992px)").matches) {
                var header = $(".horizontal-menu");
                if ($(window).scrollTop() >= 70) {
                    $(header).addClass("fixed-on-scroll");
                } else {
                    $(header).removeClass("fixed-on-scroll");
                }
            }
        });
    });

    // focus input when clicking on search icon
    $("#navbar-search-icon").click(function () {
        $("#navbar-search-input").focus();
    });
})(jQuery);

(function ($) {
    "use strict";
    //Open submenu on hover in compact sidebar mode and horizontal menu mode
    $(document).on(
        "mouseenter mouseleave",
        ".sidebar .nav-item",
        function (ev) {
            var body = $("body");
            var sidebarIconOnly = body.hasClass("sidebar-icon-only");
            var sidebarFixed = body.hasClass("sidebar-fixed");
            if (!("ontouchstart" in document.documentElement)) {
                if (sidebarIconOnly) {
                    if (sidebarFixed) {
                        if (ev.type === "mouseenter") {
                            body.removeClass("sidebar-icon-only");
                        }
                    } else {
                        var $menuItem = $(this);
                        if (ev.type === "mouseenter") {
                            $menuItem.addClass("hover-open");
                        } else {
                            $menuItem.removeClass("hover-open");
                        }
                    }
                }
            }
        }
    );
})(jQuery);

(function ($) {
    "use strict";
    function addActiveClass(element) {
        if (currentciudadano !== "") {
            //for other url
            if (element.attr("href").indexOf(currentciudadano) !== -1) {
                element
                    .parents(".nav-item-ciudadano")
                    .last()
                    .addClass("active");
            }
        }
    }
    var currentciudadano = location.pathname
        .split("/")
        .slice(-1)[0]
        .replace(/^\/|\/$/g, "");
    $(".nav-floating-left a").each(function () {
        var $this = $(this);
        addActiveClass($this);
    });
})(jQuery);

$(document).on("change", ".cascada", function (event) {
    let $this = $(this);
    let hijo = $this.data("hijo");
    let id = $this.val();
    if (id === "") {
        return;
    }
    let keyName = "id";
    //if (typeof $this.data("key") !== "undefined") {
    //    keyName = $this.data("key");
    //}

    $.ajax({
        url: $this.data("url"),
        method: "GET",
        data: {
            [keyName]: id,
        },
    })
        .done(function (result) {
            let noRetornar = $this.data("no-retornar");
            let callback = $this.data("callback");
            let existeCallback =
                typeof callback !== "undefined" && typeof window[callback] === "function";
            if (typeof noRetornar === "undefined" && existeCallback) {
                window[callback](result, id);
                return;
            }

            hijo = hijo.split(";");
            for (let index = 0; index < hijo.length; index++) {
                const identificador = hijo[index];
                const element = $(identificador);
                if (element.length != 0) {
                    element.empty();
                    result.data.forEach((item) => {
                        let miSelect = document.querySelector(identificador);
                        let opt = document.createElement("option");
                        opt.appendChild(document.createTextNode(item.text));
                        opt.value = item.value;
                        miSelect.appendChild(opt);
                    });
                    element.selectpicker("refresh");
                    if (
                        element.data("val") &&
                        element.data("val") != undefined &&
                        element.data("val") != null
                    ) {
                        element.val(element.data("val"));
                    }
                }
            }
            if (hijo.length) {
                if (existeCallback) {
                    window[callback](result, id);
                }
            }
        })
        .fail(function () {
            alert("OCURRI� UN ERROR, INTENTA M�S TARDE");
        });
});